export default function () {
  return {
    validationError: false,
    bypassValidation: false,
    lastValidationAttempt: null,
  };
}
